export default "__VITE_ASSET__OAsfJEMS__"